import { FunctionComponent, ReactNode } from "react";

/** The rail's uppercase section title (mockup `.rail h4`). */
export const RailHeading: FunctionComponent<{ children: ReactNode }> = ({ children }) => (
	<h4 className="mt-4 text-[11px] font-semibold uppercase tracking-wide text-text-meta first:mt-0">
		{children}
	</h4>
);

/** One key / value pair of a `.kv` grid; the parent is `grid grid-cols-[auto_1fr]`. */
export const RailRow: FunctionComponent<{ label: string; children: ReactNode }> = ({
	label,
	children,
}) => (
	<>
		<span className="text-text-meta">{label}</span>
		<span className="min-w-0 text-text">{children}</span>
	</>
);
